const getFetchUrl = () => {
  return "/cmscontent";
};

export default getFetchUrl;
